import { SimProfileDetails } from './SimProfileDetails';
import { SuspenseLoadingView } from '../../common/components/SuspenseLoadingView';
import Box from '@mui/material/Box';
import { DetailsSkeleton } from '../../common/components/DetailsSkeleton';
import { SimProfileTagProvider } from 'simInventory/Tags/SimProfileTagProvider';
import { TabPanelWithErrorHandling } from 'src/common/components/AppLayout/Components/TabPanelWithErrorHandling';
import { useTranslation } from 'react-i18next';
import { ErrorCodes } from 'src/common/responseCodes';

const IGNORED_ERRORS = [ErrorCodes.NotFound];
export const SimProfileDetailsTab = () => {
  const { t } = useTranslation();
  return (
    <TabPanelWithErrorHandling
      name={t('simInventory.details.tabs.general')}
      ignoreErrorMessages={IGNORED_ERRORS}
    >
      <SimProfileTagProvider>
        <SuspenseLoadingView
          loadFallback={
            <Box
              sx={{
                pt: 12,
                pb: 24,
                px: 64,
                mt: 44,
              }}
            >
              <DetailsSkeleton numberOfRepetitions={8} />
            </Box>
          }
        >
          <SimProfileDetails />
        </SuspenseLoadingView>
      </SimProfileTagProvider>
    </TabPanelWithErrorHandling>
  );
};
